import { fetcher } from '#lib/backendFetcher';

/**
 * Adds hand-picked Google Places to an existing search query.
 * The backend persists them into the shared company pool (deduped) before linking,
 * and charges company credits only for newly-added companies.
 * @param {string} prospectQueryId - UUID of the search query
 * @param {Array<Object>} places - Transformed Google Places to add
 * @returns {Promise<{data: Object|null, error: Error|null}>}
 */
export const addCompaniesToProspectQuery = async (prospectQueryId, places) => {
	try {
		const data = await fetcher(`/api/v1/leads/queries/${prospectQueryId}/companies/from-places`, {
			method: 'POST',
			body: { places },
		});
		return { data, error: null };
	} catch (error) {
		return { data: null, error };
	}
};
